const BASE_URL = process.env.REACT_APP_BASE_URL

// AUTH ENDPOINTS
export const endpoints = {
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  SIGNUP_API: BASE_URL + "/auth/signup",
  LOGIN_API: BASE_URL + "/auth/login",
  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
  GOOGLE_AUTH: BASE_URL + "/auth/googleauth",
}

// PROFILE ENDPOINTS
export const profileEndpoints = {
  GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
  GET_USER_ENROLLED_COURSES_API: BASE_URL + "/profile/getEnrolledCourses",
  GET_INSTRUCTOR_DATA_API: BASE_URL + "/profile/instructorDashboard",
}

// STUDENTS ENDPOINTS
export const studentEndpoints = {
  COURSE_PAYMENT_API: BASE_URL + "/payment/capturePayment",
  COURSE_VERIFY_API: BASE_URL + "/payment/verifyPayment",
  SEND_PAYMENT_SUCCESS_EMAIL_API: BASE_URL + "/payment/sendPaymentSuccessEmail",
}

// COURSE ENDPOINTS
export const courseEndpoints = {
  GET_ALL_COURSE_API: BASE_URL + "/course/getAllCourses",
  COURSE_DETAILS_API: BASE_URL + "/course/getCourseDetails",
  EDIT_COURSE_API: BASE_URL + "/course/editCourse",
  COURSE_CATEGORIES_API: BASE_URL + "/course/showAllCategories",
  CREATE_COURSE_API: BASE_URL + "/course/createCourse",
  CREATE_SECTION_API: BASE_URL + "/course/addSection",
  CREATE_SUBSECTION_API: BASE_URL + "/course/addSubSection",
  UPDATE_SECTION_API: BASE_URL + "/course/updateSection",
  UPDATE_SUBSECTION_API: BASE_URL + "/course/updateSubSection",
  GET_ALL_INSTRUCTOR_COURSES_API: BASE_URL + "/course/getInstructorCourses",
  DELETE_SECTION_API: BASE_URL + "/course/deleteSection",
  DELETE_SUBSECTION_API: BASE_URL + "/course/deleteSubSection",
  DELETE_COURSE_API: BASE_URL + "/course/deleteCourse",
  GET_FULL_COURSE_DETAILS_AUTHENTICATED: BASE_URL + "/course/getFullCourseDetails",
  LECTURE_COMPLETION_API: BASE_URL + "/course/updateCourseProgress",
  CREATE_RATING_API: BASE_URL + "/course/createRating",
  RECOMMENDATIONS_API: BASE_URL + "/course/recommendations",
}

// RATINGS AND REVIEWS
export const ratingsEndpoints = {
  REVIEWS_DETAILS_API: BASE_URL + "/course/getReviews",
}

// CATAGORIES API
export const categories = {
  CATEGORIES_API: BASE_URL + "/course/showAllCategories",
}

// CATALOG PAGE DATA
export const catalogData = {
  CATALOGPAGEDATA_API: BASE_URL + "/course/getCategoryPageDetail",
}

// CONTACT-US API
export const contactusEndpoint = {
  CONTACT_US_API: BASE_URL + "/reach/contact",
}

// SETTINGS PAGE API
export const settingsEndpoints = {
  UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
  UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
  DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
}

// AI / GEMINI ENDPOINTS
export const aiEndpoints = {
  AI_CHAT_API: BASE_URL + "/ai/chat",
  AI_DESCRIBE_COURSE_API: BASE_URL + "/ai/describe-course",
}

// ADMIN ANALYTICS ENDPOINTS
export const adminEndpoints = {
  OVERVIEW_API: BASE_URL + "/analytics/overview",
  ENROLLMENT_TREND_API: BASE_URL + "/analytics/enrollment-trend",
  TOP_COURSES_API: BASE_URL + "/course/recommendations",
  RECENT_USERS_API: BASE_URL + "/analytics/recent-users",
}

// ML / RECOMMENDATION ENDPOINTS (Admin)
export const mlEndpoints = {
  // Trigger ML model retraining (Admin only - POST)
  ML_TRAIN_API: BASE_URL + "/course/recommendations/train",
  // Get personalised / global recommendations with ML metadata
  ML_RECOMMENDATIONS_API: BASE_URL + "/course/recommendations",
  // Get similar courses for a given courseId (content-based)
  ML_SIMILAR_COURSES_API: (courseId) =>
    BASE_URL + `/course/${courseId}/similar`,
}

// SEARCH API
export const searchEndpoints = {
  COURSE_SEARCH_API: BASE_URL + "/course/searchCourse",
  SEARCH_SUGGESTIONS_API: BASE_URL + "/course/searchSuggestions",
  INSTRUCTOR_SEARCH_API: BASE_URL + "/course/instructorDetails",
}


// DATA ENGINEERING PIPELINE ENDPOINTS
export const pipelineEndpoints = {
  PIPELINE_EVENT_API:      BASE_URL + "/pipeline/event",
  PIPELINE_EVENTS_API:     BASE_URL + "/pipeline/events",
  PIPELINE_SUMMARY_API:    BASE_URL + "/pipeline/summary",
  PIPELINE_FUNNEL_API:     BASE_URL + "/pipeline/funnel",
  PIPELINE_RETENTION_API:  BASE_URL + "/pipeline/retention",
  PIPELINE_AGGREGATE_API:  BASE_URL + "/pipeline/aggregate",
}

// Convenience re-export used by analytics.js
export const PIPELINE_EVENT_API = BASE_URL + "/pipeline/events";
